module.exports = __webpack_public_path__ + "img/editGreen.558f86fa.svg";